module.exports = __webpack_public_path__ + "media/images/apple-icon-72x72-6086c05d.png";